import request from '@/utils/request'
import URL from '@/api/urlTranslator'
import { getUserInfo } from '@/utils/auth'
import checkPermission from '../../utils/permission'

export function getBillingGroupList(requestBody) {
  return request({
    url: URL.act.billingGroup.advQueryBillingGroupList,
    method: 'post',
    data: requestBody
  })
}

export function getBillingList(requestBody) {
  return request({
    url: URL.act.billing.advQueryBillingList,
    method: 'post',
    data: requestBody
  })
}

export function setBillingsNo(requestBody) {
  return request({
    url: URL.act.billing.setBillingsNo,
    method: 'post',
    data: requestBody
  })
}

export function getReconciliationChargeList(requestBody) {
  return request({
    url: URL.act.reconciliation.advQueryReconciliationChargeList,
    method: 'post',
    data: requestBody
  })
}

export function getReconciliationJobList(requestBody) {
  return request({
    url: URL.act.reconciliation.advQueryReconciliationJobList,
    method: 'post',
    data: requestBody
  })
}

export function getBillingGroupDetail(uuid) {
  const params = { uuid }
  return request({
    url: URL.act.billingGroup.getBillingGroupDetail,
    method: 'get',
    params
  })
}

export function batchDelBillingGroup(keys) {
  const data = keys
  return request({
    url: URL.act.billingGroup.batchDelBillingGroup,
    method: 'delete',
    data
  })
}

export function batchUnConfirmBillGroup(requestBody, isCancelConfirmedBill) {
  return request({
    url: URL.act.billingGroup.batchUnConfirmBillGroup,
    method: 'post',
    data: requestBody,
    params: { isCancelConfirmedBill }
  })
}

export function batchConfirmBillGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.batchConfirmBillGroup,
    method: 'post',
    data: requestBody
  })
}

export function batchReviewBillGroup(keys, review) {
  return request({
    url: URL.act.billingGroup.batchReviewBillGroup,
    method: 'post',
    data: keys,
    params: { review }
  })
}

export function loadBillingChargeOfBillingGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.loadBillingChargeOfBillingGroup,
    method: 'post',
    data: requestBody
  })
}

export function loadBillingJobOfBillingGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.loadBillingJobOfBillingGroup,
    method: 'post',
    data: requestBody
  })
}

export function loadBillingOfBillingGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.loadBillingOfBillingGroup,
    method: 'post',
    data: requestBody
  })
}

export function saveBillingGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.saveBillingGroup,
    method: 'post',
    data: requestBody
  })
}

export function queryAddBillingList(requestBody) {
  return request({
    url: URL.act.billing.queryAddBillingList,
    method: 'post',
    data: requestBody
  })
}

export function getBillingDetail(uuid) {
  const params = { uuid }
  return request({
    url: URL.act.billing.getBillingDetail,
    method: 'get',
    params
  })
}

export function loadChargeOfBilling(requestBody) {
  return request({
    url: URL.act.billing.loadChargeOfBilling,
    method: 'post',
    data: requestBody
  })
}

// 业务详细tab页签-账单-根据费用uuids获取账单费用VO
export function loadChargeByUuids(data) {
  return request({
    url: URL.act.billing.loadChargeByUuids,
    method: 'post',
    data
  })
}

export function loadJobOfBilling(requestBody) {
  return request({
    url: URL.act.billing.loadJobOfBilling,
    method: 'post',
    data: requestBody
  })
}

export function batchDelBilling(keys, location) {
  const data = keys
  return request({
    url: URL.act.billing.batchDelBilling,
    method: 'delete',
    data,
    params: { location }
  })
}

export function batchUnConfirmBilling(requestBody, sycCharge, location) {
  return request({
    url: URL.act.billing.batchUnConfirmBilling + '?sycCharge=' + sycCharge + '&location=' + location,
    method: 'post',
    data: requestBody
  })
}

export function batchConfirmBilling(requestBody, location) {
  return request({
    url: URL.act.billing.batchConfirmBilling,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function getCurrencyAmount(requestBody) {
  return request({
    url: URL.act.billingGroup.calculateCurrencyAmount,
    method: 'post',
    data: requestBody
  })
}

export function getAddChargeList(requestBody) {
  return request({
    url: URL.act.billing.getAddChargeListOfBilling,
    method: 'post',
    data: requestBody
  })
}

export function saveBilling(requestBody) {
  return request({
    url: URL.act.billing.saveBilling,
    method: 'post',
    data: requestBody
  })
}
export function saveSplitBillingFunc(requestBody, location) {
  return request({
    url: URL.act.billing.saveSplitBilling,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function updateBillingDate(requestBody) {
  return request({
    url: URL.act.billing.updateBillingDate,
    method: 'post',
    data: requestBody
  })
}

export function saveReconciliation(requestBody) {
  return request({
    url: URL.act.reconciliation.saveReconciliation,
    method: 'post',
    data: requestBody
  })
}

export function getBillingTreeForInvoice(requestBody) {
  return request({
    url: URL.act.billing.getBillingTreeForInvoice,
    method: 'post',
    data: requestBody
  })
}

export function getBillingGroupTreeForInvoice(requestBody) {
  return request({
    url: URL.act.billingGroup.getBillingGroupTreeForInvoice,
    method: 'post',
    data: requestBody
  })
}
// 业务页签账单查询
export function queryTabBilling(requestBody) {
  const privileges = []
  if (!getUserInfo().admin) {
    if (!checkPermission(['role_billTab_jobAllOverseaBilling'])) {
      if (checkPermission(['role_billTab_jobDepOverseaBilling'])) { privileges.push('jobDepOverseaBilling') } else { privileges.push('jobSelfOverseaBilling') }
    }
    if (!checkPermission(['role_InternalBillInfo_jobAllInternalBilling'])) {
      if (checkPermission(['role_InternalBillInfo_jobDepInternalBilling'])) { privileges.push('jobDepInternalBilling') } else { privileges.push('jobSelfInternalBilling') }
    }
  }
  requestBody.privileges = privileges
  return request({
    url: URL.act.billing.queryTabBilling,
    method: 'post',
    data: requestBody
  })
}
/**
 * CARGO-2262，业务详情-账单：根据账单所属分公司
 * 与原有queryTabBilling比较：传入分公司参数不同
 */
export function queryTabBillingByBranchId(requestBody) {
  const privileges = []
  if (!getUserInfo().admin) {
    if (!checkPermission(['role_billTab_jobAllOverseaBilling'])) {
      if (checkPermission(['role_billTab_jobDepOverseaBilling'])) { privileges.push('jobDepOverseaBilling') } else { privileges.push('jobSelfOverseaBilling') }
    }
    if (!checkPermission(['role_InternalBillInfo_jobAllInternalBilling'])) {
      if (checkPermission(['role_InternalBillInfo_jobDepInternalBilling'])) { privileges.push('jobDepInternalBilling') } else { privileges.push('jobSelfInternalBilling') }
    }
  }
  requestBody.privileges = privileges

  return request({
    url: URL.act.billing.queryTabBilling,
    method: 'post',
    data: requestBody
  })
}

// 业务页签账单-国内账单确认操作
export function updateBillingCharge(params) {
  return request({
    url: URL.act.billing.updateBillingCharge,
    method: 'post',
    params
  })
}

// 业务页签账单-国内账单取消确认操作
export function cancelUpdateBillingCharge(params) {
  return request({
    url: URL.act.billing.cancelUpdateBillCharge,
    method: 'post',
    params
  })
}

// 业务页签账单-国内账单根据账单号复核账单
export function recheckBilling(params) {
  return request({
    url: URL.act.billing.recheckBilling,
    method: 'post',
    data: params
  })
}

// 业务页签账单-国内账单根据账单号取消复核账单
export function cancelRecheckBilling(params) {
  return request({
    url: URL.act.billing.cancelRecheckBilling,
    method: 'post',
    data: params
  })
}

// 业务页签账单-国内账单刪除
export function deleteBilling(params) {
  return request({
    url: URL.act.billing.deleteBilling,
    method: 'delete',
    params
  })
}
// 业务页签账单-国外账单loadAgentRelationCharge
export function loadAgentRelationCharge(billKey) {
  const params = { billKey }
  return request({
    url: URL.act.billing.loadAgentRelationCharge,
    method: 'get',
    params
  })
}

// 业务页签账单-国外账单审核
export function autidBilling(params) {
  return request({
    url: URL.act.billing.autidBilling,
    method: 'post',
    params
  })
}

// 业务页签账单-国外账单作废
export function invalidBilling(params) {
  return request({
    url: URL.act.billing.invalidBilling,
    method: 'post',
    params
  })
}

// 校验代理账单编号是否重复
export function checkPartyBillingNoExist(params) {
  return request({
    url: URL.act.billing.checkPartyBillingNoExist,
    method: 'get',
    params
  })
}
// 校验代理账单编号是否重复
export function batchCheckPartyBillingNoExist(data, params) {
  return request({
    url: URL.act.billing.batchCheckPartyBillingNoExist,
    method: 'post',
    data,
    params: params
  })
}

// 业务页签账单-编辑代理账单编号
export function savePartyBillingNo(params) {
  return request({
    url: URL.act.billing.savePartyBillingNo,
    method: 'post',
    params
  })
}

// 国外账单保存
export function saveOverseaBilling(requestBody) {
  return request({
    url: URL.act.billing.saveOverseaBilling,
    method: 'post',
    data: requestBody
  })
}

// 国外账单保存
export function saveOverseaSplitBillingFunc(requestBody, location) {
  return request({
    url: URL.act.billing.saveOverseaSplitBilling,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

// 代理分成账单保存
export function saveAgentBilling(requestBody) {
  return request({
    url: URL.act.billing.saveAgentBilling,
    method: 'post',
    data: requestBody
  })
}

// 标记账单
export function signBilling(requestBody) {
  return request({
    url: URL.act.billing.signBilling,
    method: 'post',
    data: requestBody
  })
}

// 取消标记账单
export function cancelSignBilling(requestBody) {
  return request({
    url: URL.act.billing.cancelSignBilling,
    method: 'post',
    data: requestBody
  })
}

// 账单快捷查询
export function simpleQueryBillingList(requestBody) {
  return request({
    url: URL.act.billing.simpleQueryBillingList,
    method: 'post',
    data: requestBody
  })
}

// 对账单快捷查询
export function simpleQueryBillingGroupList(requestBody) {
  return request({
    url: URL.act.billingGroup.simpleQueryBillingGroupList,
    method: 'post',
    data: requestBody
  })
}

// 业务页签账单-国外账单 账单号生成
export function setBillingNo(params) {
  return request({
    url: URL.act.billing.setBillingNo,
    method: 'post',
    params
  })
}
// 业务页签账单-国外账单 打印修改账单状态
export function updateBillingState(params) {
  return request({
    url: URL.act.billing.updateBillingState,
    method: 'post',
    params
  })
}

export function queryChargeList(requestBody) {
  return request({
    url: URL.act.charge.queryChargeList,
    method: 'post',
    data: requestBody
  })
}

// 批量生成账单
export function batchGenerateBilling(requestBody) {
  return request({
    url: URL.act.billing.batchGenerateBilling,
    method: 'post',
    data: requestBody
  })
}
// 海外结算中心查询
export function queryBillOverseas(requestBody) {
  return request({
    url: URL.act.billing.queryBillOverseas,
    method: 'post',
    data: requestBody
  })
}
// 新版海外结算中心查询
export function queryBillOverseasAdv(requestBody) {
  return request({
    url: URL.act.billing.queryBillOverseasAdv,
    method: 'post',
    data: requestBody
  })
}
// 海外结算中心查询
export function batchUpdateStates(requestBody, params) {
  return request({
    url: URL.act.billing.batchUpdateStates,
    method: 'post',
    data: requestBody,
    params: params
  })
}

// 强制删除
export function forceDeleteBilling(data, location) {
  return request({
    url: URL.act.billing.forceDeleteBilling,
    method: 'post',
    data: data,
    params: { location }
  })
}

// 校验账单是否可强制删除
export function validateForceDeleteBilling(data) {
  return request({
    url: URL.act.billing.validateForceDeleteBilling,
    method: 'post',
    data: data
  })
}

// 校验对账单中是否含有代理分成账单
export function hasAgentBillingForBillingGroup(requestBody) {
  return request({
    url: URL.act.billingGroup.hasAgentBilling,
    method: 'post',
    data: requestBody
  })
}

// 查询对账单下的账单
export function queryBillingByGroupId(requestBody) {
  return request({
    url: URL.act.billingGroup.queryBillingByGroupId,
    method: 'post',
    data: requestBody
  })
}

// 重发账单信息
export function sendBilling(requestBody) {
  return request({
    url: URL.act.billing.sendBilling,
    method: 'post',
    data: requestBody
  })
}

// 重发账单信息（通过jobKeys）
export function sendBillingByJobKeys(requestBody) {
  return request({
    url: URL.act.billing.sendBillingByJobKeys,
    method: 'post',
    data: requestBody
  })
}

// 预收标记
export function prePayment(requestBody) {
  return request({
    url: URL.act.billing.prePayment,
    method: 'post',
    data: requestBody
  })
}

// 取消预收标记
export function cancelPrePayment(requestBody) {
  return request({
    url: URL.act.billing.cancelPrePayment,
    method: 'post',
    data: requestBody
  })
}

export function getInternalBillSameGroup(params) {
  return request({
    url: URL.act.billing.getInternalBillSameGroup,
    method: 'get',
    params
  })
}

export function getOverseaBillSameGroup(params) {
  return request({
    url: URL.act.billing.getOverseaBillSameGroup,
    method: 'get',
    params
  })
}

export function getBillingInvoiceRemarkFun(data) {
  return request({
    url: URL.act.billing.getBillingInvoiceRemarkUrl,
    method: 'post',
    data
  })
}

// 按账单Uuid批量查询Job信息
export function getChargeByBillingKeys(requestBody) {
  return request({
    url: URL.act.billing.getChargeByBillingKeys,
    method: 'post',
    data: requestBody
  })
}

// 校验账单是否可红冲
export function validateRedPunchBilling(data) {
  return request({
    url: URL.act.billing.validateRedPunchBilling,
    method: 'post',
    data: data
  })
}

/**
 * 红冲账单
 * @param requestBody
 * @returns {*}
 */
export function redPunchBilling(requestBody) {
  return request({
    url: URL.act.billing.redPunchBilling,
    method: 'post',
    data: requestBody
  })
}

/**
 * 批量查询job通过uuids
 */
export function queryBillingsByChargeUuid(data) {
  return request({
    url: URL.act.billing.queryBillingsByChargeUuid,
    method: 'post',
    data: data
  })
}

export function syncCloudPlatformQL(requestBody) {
  return request({
    url: URL.act.billing.syncCloudPlatformQL,
    method: 'post',
    data: requestBody
  })
}

export function updateChargeReviewRemark(requestBody) {
  return request({
    url: URL.act.billing.updateChargeReviewRemark,
    method: 'post',
    data: requestBody
  })
}

export function updateFinancialRemarks(requestBody) {
  return request({
    url: URL.act.billing.updateFinancialRemarks,
    method: 'post',
    data: requestBody
  })
}

export function updateConfirmationLetterRemarks(requestBody) {
  return request({
    url: URL.act.billing.updateConfirmationLetterRemarks,
    method: 'post',
    data: requestBody
  })
}

export function batchUpdateChargeAccountId(requestBody) {
  return request({
    url: URL.act.billing.batchUpdateChargeAccountId,
    method: 'post',
    data: requestBody
  })
}

export function batchUpdateChargeInvoiceTitle(requestBody) {
  return request({
    url: URL.act.billing.batchUpdateChargeInvoiceTitle,
    method: 'post',
    data: requestBody
  })
}
